<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body text-center">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="my-0  font-bold"
          v-text="'Share with Organizations'"
        />
      </header>
      <p
        v-if="loading"
        v-text="'Loading'"
      />
      <ul
        v-if="!loading && shareableOrganizations.data.length"
        class="scroll-checklist scroll-blue"
      >
        <li
          v-for="organization in shareableOrganizations.data"
          :key="organization.uuid"
        >
          <input
            :id="`organization-${organization.uuid}`"
            v-model="selectedOrganizations"
            type="checkbox"
            :name="`organization-${organization.uuid}`"
            :value="organization.uuid"
          >
          <label
            :for="`organization-${organization.uuid}`"
            class="checkbox"
            v-text="organization.attributes.name"
          />
        </li>
      </ul>
      <p
        v-if="!loading && !shareableOrganizations.data.length"
        v-text="'No eligible organizations to share with'"
      />
      <footer class="text-center">
        <button
          type="button"
          class="btn btn--sm mb-2"
          :disabled="!selectedOrganizations.length"
          :aria-disabled="!selectedOrganizations.length"
          @click.prevent="sendToOrganizations"
          v-html="sendToOrganizationsText"
        />
      </footer>
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'SendToOrganizationsModal',
  data() {
    return {
      loading: false,
      search: '',
      selectedOrganizations: [],
      shareableOrganizations: {
        data: [],
      },
    }
  },
  computed: {
    shareable() {
      return this.$store.state.document.sendToOrganizationsModal.resource
    },
    show() {
      return this.$store.state.document.sendToOrganizationsModal.open
    },
    sendToOrganizationsText() {
      if (!this.selectedOrganizations.length) {
        return 'Select organization(s)'
      }

      return this.selectedOrganizations.length === 1
        ? 'Share with 1 organization'
        : `Share with ${this.selectedOrganizations.length} organizations`
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.loading = true

        this.fetch()
      }
    },
  },
  methods: {
    fetch() {
      this.$api
        .active()
        .get('unions?include=shareableUnions')
        .then((response) => {
          this.loading = false
          this.shareableOrganizations = response.data.shareableUnions
        })
    },
    sendToOrganizations() {
      this.$api
        .active()
        .post(this.shareable._type.toLowerCase() + 's/' + this.shareable.uuid + '/shares', {
          unionUuids: this.selectedOrganizations,
        })
        .then((response) => {
          this.$emit(this.shareable._type.toLowerCase() + 'HasBeenSentToOrganizations')

          const vm = this

          response.data.meta.errors.forEach(function (errorMessage) {
            vm.$store.commit('baseAddNotification', {
              type: 'error',
              title: 'Error',
              text: errorMessage.message,
              timeout: false,
            })
          })

          response.data.meta.successful.forEach(function (successMessage) {
            vm.$store.commit('baseAddNotification', {
              type: 'success',
              title: 'Success',
              text: successMessage.message,
            })
          })

          this.close()
        })
    },
    close() {
      this.$store.commit('documentCloseSendToOrganizationsModal')

      // Delay to allow animation to complete before resetting.
      const vm = this

      setTimeout(function () {
        vm.shareableOrganizations = {
          data: [],
        }
        vm.selectedOrganizations = []
      }, 2000)
    },
  },
}
</script>
